(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-tabs"] && !Shopify.designMode) return;
  try {
    
  class NordriTabs extends HTMLElement {
    connectedCallback() {
      /* Each tab block renders its button next to its panel; gather the buttons into one row. */
      const row = this.querySelector('.nordri-tabs__tabs');
      this.querySelectorAll('.nordri-tabs__panels .nordri-tabs__tab').forEach((tab) => row.append(tab));
      this.tabs = [...row.querySelectorAll('[role="tab"]')];
      this.ink = document.createElement('span');
      this.ink.className = 'nordri-tabs__ink';
      this.ink.setAttribute('aria-hidden', 'true');
      row.append(this.ink);
      this.moveInk();
      requestAnimationFrame(() => this.ink.setAttribute('data-ready', ''));
      /* Keep the ink under the open tab when fonts load or the row changes size. */
      this.resizeObserver = new ResizeObserver(() => this.moveInk());
      this.resizeObserver.observe(row);
      this.addEventListener('shopify:block:select', (event) => {
        const tab = this.tabs.find((t) => t.dataset.blockId === event.detail.blockId);
        if (tab) this.select(tab);
      });
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => this.onKey(event, tab));
      });

      /* Run the fire flakes only while the section is on screen. */
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-in-view', entry.isIntersecting);
        });
        this.observer.observe(this);
      } else {
        this.setAttribute('data-in-view', '');
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }

    moveInk() {
      const tab = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
      if (!tab || !this.ink) return;
      this.ink.style.left = `${tab.offsetLeft}px`;
      this.ink.style.width = `${tab.offsetWidth}px`;
    }

    select(tab) {
      this.tabs.forEach((t) => {
        const selected = t === tab;
        t.setAttribute('aria-selected', String(selected));
        t.tabIndex = selected ? 0 : -1;
        const panel = this.querySelector(`#${t.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !selected;
      });
      this.moveInk();
      const row = tab.parentElement;
      row.scrollTo({ left: tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
      /* The carousel measures itself on resize; it was hidden until now. */
      window.dispatchEvent(new Event('resize'));
    }

    onKey(event, tab) {
      const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
      if (!step) return;
      event.preventDefault();
      const next = this.tabs[(this.tabs.indexOf(tab) + step + this.tabs.length) % this.tabs.length];
      next.focus();
      this.select(next);
    }
  }

  if (!customElements.get('nordri-tabs')) customElements.define('nordri-tabs', NordriTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordri-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  /* The banners slide like the Apple carousel: the same set is printed more than once, so the
     track can always step one banner further and be put back silently when it passes the end. */
  class NordriBannerCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.count = Number(this.dataset.count || 0);
      if (!this.track || this.count < 2) return;

      this.slides = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.step = 0;
      this.per = 1;
      this.visible = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.playing = this.dataset.autoplay === 'true' && !this.reduced;
      this.interval = Number(this.dataset.interval || 5000);
      this.speed = parseFloat(getComputedStyle(this).getPropertyValue('--bc-speed')) || 600;

      this.measure();
      this.apply(false);

      this.sizer = new ResizeObserver(() => {
        const before = this.step;
        this.measure();
        if (this.step !== before) this.apply(false);
      });
      this.sizer.observe(this.slides[0]);

      this.track.addEventListener('transitionend', (event) => {
        if (event.propertyName !== 'transform') return;
        this.settle();
      });

      this.dots.forEach((dot) => dot.addEventListener('click', () => this.jump(Number(dot.dataset.dot))));

      this.addDrag();

      /* Autoplay only runs while the section is on screen, the tab is in front and nobody is
         pointing at it - and the videos follow the same rule, so nothing decodes out of sight. */
      this.observer = new IntersectionObserver(
        (entries) => {
          const wasVisible = this.visible;
          this.visible = entries[0].isIntersecting;
          this.resetTimer();
          this.paintVideos();
          /* The row moves as soon as it comes into view instead of waiting a full interval. */
          clearTimeout(this.kick);
          if (this.visible && !wasVisible && this.playing && !this.hovered) {
            this.kick = setTimeout(() => this.go(1), 700);
          }
        },
        { threshold: 0.2 }
      );
      this.observer.observe(this);

      this.onVisibility = () => this.resetTimer();
      document.addEventListener('visibilitychange', this.onVisibility);

      this.addEventListener('pointerenter', () => {
        this.hovered = true;
        this.resetTimer();
      });
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.resetTimer();
      });
      this.addEventListener('focusin', () => {
        this.hovered = true;
        this.resetTimer();
      });
      this.addEventListener('focusout', () => {
        this.hovered = false;
        this.resetTimer();
      });

      this.resetTimer();
      this.paint();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.settleTimer);
      clearTimeout(this.kick);
      if (this.observer) this.observer.disconnect();
      if (this.sizer) this.sizer.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    /* One step is the distance between two banners, gap included, measured from the page itself. */
    measure() {
      if (this.slides.length < 2) return;
      this.step = this.slides[1].getBoundingClientRect().left - this.slides[0].getBoundingClientRect().left;
      const cards = parseFloat(getComputedStyle(this).getPropertyValue('--bc-cards'));
      this.per = Math.max(1, Math.round(cards || 1));
    }

    apply(animate) {
      this.track.style.transitionDuration = animate ? '' : '0ms';
      this.track.style.transform = 'translate3d(' + -this.index * this.step + 'px, 0, 0)';
      if (!animate) {
        void this.track.offsetWidth;
        this.track.style.transitionDuration = '';
      }
      clearTimeout(this.settleTimer);
      if (animate) this.settleTimer = setTimeout(() => this.settle(), this.speed + 80);
      this.paint();
    }

    /* Past the end of the first set the track is put back by one whole set. The banner on screen
       is identical, so the jump cannot be seen. */
    settle() {
      clearTimeout(this.settleTimer);
      this.locked = false;
      if (this.index >= this.count) {
        this.index -= this.count;
        this.apply(false);
      }
    }

    go(delta) {
      if (this.locked) return;
      this.locked = true;
      setTimeout(() => {
        this.locked = false;
      }, 800);

      if (this.index + delta < 0) {
        /* Going back from the first banner: stand on the copy one set further along, then slide. */
        this.index = this.count;
        this.apply(false);
        setTimeout(() => {
          this.index -= 1;
          this.apply(true);
        }, 20);
      } else {
        this.index += delta;
        this.apply(true);
      }
      this.resetTimer();
    }

    jump(target) {
      if (target === this.index % this.count) return;
      this.index = target;
      this.apply(true);
      this.resetTimer();
    }

    paint() {
      const current = ((this.index % this.count) + this.count) % this.count;
      this.dots.forEach((dot, i) => {
        if (i === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.paintVideos();
    }

    paintVideos() {
      this.slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        const onScreen = this.visible && i >= this.index && i < this.index + this.per;
        if (onScreen) {
          const played = video.play();
          if (played && played.catch) played.catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    resetTimer() {
      clearInterval(this.timer);
      if (!this.playing || !this.visible || this.hovered || document.hidden) return;
      this.timer = setInterval(() => this.go(1), this.interval);
    }

    /* Dragging follows the finger, then lands on the nearest banner. A drag never opens the link. */
    addDrag() {
      let start = null;
      let moved = 0;

      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        start = event.clientX;
        moved = 0;
        this.dataset.dragging = 'true';
      });

      this.track.addEventListener('pointermove', (event) => {
        if (start === null) return;
        moved = event.clientX - start;
        this.track.style.transitionDuration = '0ms';
        this.track.style.transform = 'translate3d(' + (-this.index * this.step + moved) + 'px, 0, 0)';
      });

      const release = () => {
        if (start === null) return;
        start = null;
        this.dataset.dragging = 'false';
        this.track.style.transitionDuration = '';
        if (Math.abs(moved) > this.step * 0.18) this.go(moved < 0 ? 1 : -1);
        else this.apply(true);
      };

      this.track.addEventListener('pointerup', release);
      this.track.addEventListener('pointercancel', release);
      this.track.addEventListener('pointerleave', release);
      this.track.addEventListener(
        'click',
        (event) => {
          if (Math.abs(moved) > 6) {
            event.preventDefault();
            event.stopPropagation();
          }
          moved = 0;
        },
        true
      );
    }
  }

  if (!customElements.get('nordri-banner-carousel')) {
    customElements.define('nordri-banner-carousel', NordriBannerCarousel);
  }

  /* In the editor, picking a banner brings it to the front of the row. */
  document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest('nordri-banner-carousel');
    if (!carousel || typeof carousel.jump !== 'function') return;
    const slides = Array.from(carousel.querySelectorAll('.nordri-bc__slide'));
    const position = slides.indexOf(event.target.closest('.nordri-bc__slide'));
    if (position >= 0) carousel.jump(position % carousel.count);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordri-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-top]')) return;
    window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordri-handmade"] && !Shopify.designMode) return;
  try {
    
  const RUNES = {
    a: 'ᚨ', b: 'ᛒ', c: 'ᚲ', d: 'ᛞ', e: 'ᛖ', f: 'ᚠ', g: 'ᚷ', h: 'ᚺ', i: 'ᛁ', j: 'ᛃ', k: 'ᚲ',
    l: 'ᛚ', m: 'ᛗ', n: 'ᚾ', o: 'ᛟ', p: 'ᛈ', q: 'ᚲ', r: 'ᚱ', s: 'ᛊ', t: 'ᛏ', u: 'ᚢ', v: 'ᚹ',
    w: 'ᚹ', x: 'ᚲᛊ', y: 'ᛃ', z: 'ᛉ',
  };

  class NordriEngraver extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[ref="input"]');
      this.etch = this.querySelector('[ref="etch"]');
      this.name = this.querySelector('[ref="name"]');
      this.plate = this.querySelector('.nordri-steel');
      this.style_ = [...this.etch.classList].find((c) => c.startsWith('nordri-steel__etch--'))?.split('--')[1] || 'rune';
      this.input?.addEventListener('input', () => this.render(false));
      this.querySelectorAll('[data-style]').forEach((button) => {
        button.addEventListener('click', () => {
          this.style_ = button.dataset.style;
          this.render(true);
        });
      });
      this.render(false);
    }

    toRunes(value) {
      return value
        .toLowerCase()
        .replace(/th/g, 'ᚦ')
        .replace(/ng/g, 'ᛜ')
        .replace(/[a-z]/g, (c) => RUNES[c] || '')
        .replace(/[^ᚠ-ᛪ ]/g, '')
        .replace(/ +/g, '᛫');
    }

    render(sweep) {
      const raw = (this.input?.value || '').trim() || this.input?.placeholder || 'Your name';
      this.name.textContent = this.style_ === 'rune' ? this.toRunes(raw) : raw;
      this.etch.className = `nordri-steel__etch nordri-steel__etch--${this.style_}`;
      this.querySelectorAll('[data-style]').forEach((b) => {
        b.setAttribute('aria-pressed', String(b.dataset.style === this.style_));
      });
      /* A light sweep across the plate, so a change reads as metal catching the light. */
      if (sweep) {
        this.plate.classList.remove('is-sweeping');
        void this.plate.offsetWidth;
        this.plate.classList.add('is-sweeping');
      }
    }
  }

  /* Comparison table: the rest of the rows sit under a veil until it is opened. The closed height is
     measured from the rows themselves, so any number of rows works. */
  const nordriPeek = (wrap) => {
    const rows = wrap.querySelectorAll('.nordri-made__row');
    const visible = Number(wrap.dataset.rowsVisible || 4);
    let height = 0;
    rows.forEach((row, index) => {
      if (index <= visible) height += row.getBoundingClientRect().height;
    });
    wrap.style.setProperty('--nm-peek', `${Math.round(height)}px`);
  };

  const nordriMeasure = () => document.querySelectorAll('.nordri-made__wrap').forEach(nordriPeek);
  addEventListener('load', nordriMeasure);
  addEventListener('resize', nordriMeasure);
  document.addEventListener('shopify:section:load', nordriMeasure);
  nordriMeasure();

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.nordri-made__reveal');
    if (!button) return;
    const wrap = button.closest('.nordri-made__wrap');
    const table = wrap?.querySelector('[data-rows]');
    if (!table) return;
    const open = wrap.dataset.open !== 'true';
    const label = button.querySelector('[data-more-label]');

    nordriPeek(wrap);
    if (open) table.style.maxHeight = `${table.scrollHeight}px`;
    else table.style.maxHeight = '';
    wrap.dataset.open = String(open);
    button.setAttribute('aria-expanded', String(open));
    if (label) label.textContent = open ? button.dataset.less : button.dataset.more;
  });

  if (!customElements.get('nordri-engraver')) customElements.define('nordri-engraver', NordriEngraver);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordri-product-tabs"] && !Shopify.designMode) return;
  try {
    
  /* Tabs under the product. A link to #NordriReviews opens the reviews. */
  class NordriProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-npt]')];
      this.panels = [...this.querySelectorAll('[data-npt-panel]')];
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.open(tab.dataset.npt)));
      this.addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft'].includes(e.key) || !e.target.matches('[data-npt]')) return;
        const i = this.tabs.indexOf(e.target);
        const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
        next.focus();
        this.open(next.dataset.npt);
      });
      document.addEventListener('click', (e) => {
        if (e.target.closest('a[href="#NordriReviews"]')) this.open('rev');
      });
    }

    open(key) {
      this.tabs.forEach((t) => t.setAttribute('aria-selected', String(t.dataset.npt === key)));
      this.panels.forEach((p) => (p.hidden = p.dataset.nptPanel !== key));
    }
  }

  if (!customElements.get('nordri-product-tabs')) customElements.define('nordri-product-tabs', NordriProductTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordri-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Delegated so the arrows keep working after the section is re-rendered in the editor.
     Some browsers ignore smooth scrolling here, so the position is set directly as a fallback. */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.nordri-reviews__arrow');
    if (!button) return;
    const rail = button.closest('.nordri-reviews')?.querySelector('.nordri-reviews__rail');
    const card = rail?.firstElementChild;
    if (!card) return;
    const step = (card.getBoundingClientRect().width + 14) * Number(button.dataset.dir);
    const from = rail.scrollLeft;
    rail.scrollBy({ left: step, behavior: 'smooth' });
    setTimeout(() => {
      if (rail.scrollLeft === from) rail.scrollBy({ left: step, behavior: 'instant' });
    }, 200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordri-story"] && !Shopify.designMode) return;
  try {
    
  class NordriStory extends HTMLElement {
    connectedCallback() {
      this.photo = this.querySelector('.nordri-story__stage .nordri-story__photo');
      this.caption = this.photo?.querySelector('figcaption');
      this.image = this.photo?.querySelector('img');
      this.openingImage = this.image?.getAttribute('src') || '';
      this.openingCaption = this.caption?.textContent || '';
      this.chapter = 0;

      this.addEventListener('click', (event) => {
        const target = event.target.closest('button, [data-back]');
        if (!target) return;
        if (target.dataset.mode) return this.setMode(target.dataset.mode);
        if (target.dataset.audience) return this.pickAudience(target);
        if (target.dataset.occasion) return this.pickOccasion(target);
        if (target.dataset.back !== undefined) return this.showStep(Number(target.dataset.back) || 1, target.dataset.back === '0');
        if (target.dataset.go !== undefined) return this.showChapter(Number(target.dataset.go));
      });

      /* The embers only run while the section is on screen. */
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-in-view', entry.isIntersecting);
        });
        this.observer.observe(this);
      } else {
        this.setAttribute('data-in-view', '');
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    setPhoto(src, caption) {
      if (this.image && src) this.image.setAttribute('src', src);
      if (this.caption && caption) this.caption.textContent = caption;
    }

    setMode(mode) {
      this.querySelectorAll('[data-mode]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mode === mode)));
      this.querySelectorAll('[data-mode-panel]').forEach((p) => {
        p.hidden = p.dataset.modePanel !== mode;
      });
      if (mode === 'making') this.showChapter(this.chapter);
      else this.showStep(1, true);
    }

    showStep(step, reset) {
      this.querySelectorAll('[data-step]').forEach((el) => {
        el.hidden = Number(el.dataset.step) !== step;
      });
      this.querySelectorAll('.nordri-story__progress i').forEach((bar, index) => {
        bar.classList.toggle('is-on', index < step);
      });
      if (reset) this.setPhoto(this.openingImage, this.openingCaption);
    }

    pickAudience(button) {
      this.audience = button.dataset;
      this.setPhoto(button.dataset.image, button.dataset.caption);
      const line = this.querySelector('[data-slot="line"]');
      if (line && button.dataset.line) line.textContent = button.dataset.line;
      this.showStep(2);
    }

    pickOccasion(button) {
      const pick = button.dataset.product ? button.dataset : this.audience || {};
      const note = this.querySelector('[data-slot="note"]');
      if (note && button.dataset.note) note.textContent = button.dataset.note;
      const title = this.querySelector('[data-slot="result-title"]');
      const price = this.querySelector('[data-slot="result-price"]');
      const link = this.querySelector('[data-slot="result-link"]');
      const media = this.querySelector('[data-slot="result-image"]');
      if (title && pick.product) title.textContent = pick.product;
      if (price) price.textContent = pick.price || '';
      if (link && pick.url) link.setAttribute('href', pick.url);
      if (media && pick.productImage) media.innerHTML = `<img src="${pick.productImage}" alt="" loading="lazy">`;
      if (pick.productImage) this.setPhoto(pick.productImage, this.caption?.textContent);
      this.showStep(3);
    }

    showChapter(index) {
      this.chapter = index;
      const chapters = [...this.querySelectorAll('[data-chapter]')];
      chapters.forEach((el) => {
        el.hidden = Number(el.dataset.chapter) !== index;
      });
      this.querySelectorAll('[data-go]').forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.go) === index)));
      const current = chapters[index];
      if (current) this.setPhoto(current.dataset.image, current.dataset.caption);
    }
  }

  if (!customElements.get('nordri-story')) customElements.define('nordri-story', NordriStory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordri-trust-badges"] && !Shopify.designMode) return;
  try {
    
  /* A badge number counts up the first time it is scrolled into view. */
  class NordriBadges extends HTMLElement {
    connectedCallback() {
      const numbers = this.querySelectorAll('[data-count]');
      if (!numbers.length) return;

      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const run = (element) => {
        const raw = element.dataset.count.trim();
        const match = raw.match(/-?\d+(\.\d+)?/);
        if (!match) return;
        const target = parseFloat(match[0]);
        const decimals = (match[0].split('.')[1] || '').length;
        const before = raw.slice(0, match.index);
        const after = raw.slice(match.index + match[0].length);
        const start = performance.now();
        const duration = 1600;
        element.classList.add('is-counting');
        element.addEventListener('animationend', () => element.classList.remove('is-counting'), { once: true });

        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          /* Ease out, so it slows as it lands on the number. */
          const eased = 1 - Math.pow(1 - progress, 3);
          element.textContent = before + (target * eased).toFixed(decimals) + after;
          if (progress < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            run(entry.target);
          });
        },
        { threshold: 0.6 }
      );

      numbers.forEach((number) => observer.observe(number));
    }
  }

  if (!customElements.get('nordri-badges')) customElements.define('nordri-badges', NordriBadges);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordri-wishlist"] && !Shopify.designMode) return;
  try {
    
  class NordriWishlist extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.render();
    }

    get list() {
      try {
        return JSON.parse(localStorage.getItem('nordri:wishlist') || '[]');
      } catch (e) {
        return [];
      }
    }

    set list(value) {
      try {
        localStorage.setItem('nordri:wishlist', JSON.stringify(value));
      } catch (e) {
        /* Storage can be refused in private windows. */
      }
      document.dispatchEvent(new CustomEvent('nordri:wishlist-change'));
    }

    async render() {
      const root = window.Shopify?.routes?.root || '/';
      const handles = this.list;
      const products = (
        await Promise.all(handles.map((h) => fetch(`${root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))
      ).filter(Boolean);
      this.grid.innerHTML = '';
      this.querySelector('[data-empty]').hidden = products.length > 0;
      this.querySelector('[data-count]').textContent = products.length ? `${products.length} saved` : '';

      products.forEach((p) => {
        const card = document.createElement('article');
        card.className = 'nwl__card';
        const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=600` : '';
        const price = p.price_min === p.price_max ? this.fmt.format(p.price_min / 100) : `From ${this.fmt.format(p.price_min / 100)}`;
        card.innerHTML = `
          <a class="nwl__img">${img ? `<img src="${img}" alt="" loading="lazy" width="600" height="600">` : ''}</a>
          <button class="nwl__remove" type="button" aria-label=""><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20s-7-4.4-9.2-9A5 5 0 0 1 12 6a5 5 0 0 1 9.2 5c-2.2 4.6-9.2 9-9.2 9Z"/></svg></button>
          <div class="nwl__body"><a class="nwl__name"></a><span class="nwl__price"></span></div>
          <div class="nwl__actions"><button class="button-secondary" type="button" data-add></button><a class="button" data-view></a></div>`;
        card.querySelector('.nwl__img').href = p.url;
        const name = card.querySelector('.nwl__name');
        name.href = p.url;
        name.textContent = p.title;
        card.querySelector('.nwl__price').textContent = price;
        const view = card.querySelector('[data-view]');
        view.href = p.url;
        view.textContent = this.dataset.view;
        const rm = card.querySelector('.nwl__remove');
        rm.setAttribute('aria-label', `${this.dataset.remove}: ${p.title}`);
        rm.addEventListener('click', () => {
          this.list = this.list.filter((h) => h !== p.handle);
          card.classList.add('is-leaving');
          setTimeout(() => this.render(), 350);
        });
        const add = card.querySelector('[data-add]');
        const variant = p.variants.find((v) => v.available);
        add.textContent = variant ? this.dataset.add : this.dataset.sold;
        add.disabled = !variant;
        add.addEventListener('click', () => this.add(variant, add));
        this.grid.append(card);
      });
    }

    async add(variant, button) {
      if (!variant) return;
      const root = window.Shopify?.routes?.root || '/';
      button.disabled = true;
      let events = null;
      try {
        events = await import('@shopify/events');
      } catch (e) {
        events = null;
      }
      const deferred = events?.CartLinesUpdateEvent?.createPromise?.();
      if (deferred) {
        this.dispatchEvent(new events.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variant.id), quantity: 1 }], promise: deferred.promise }));
      }
      try {
        const sections = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
        const r = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }], sections: sections.join(',') })
        });
        const j = await r.json();
        if (j.status) throw new Error(j.description || j.message);
        const cart = await (await fetch(`${root}cart.js`)).json();
        if (deferred) deferred.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'nordri-wishlist', itemCount: 1, sections: j.sections, didError: false } });
        else location.href = `${root}cart`;
      } catch (e) {
        deferred?.reject?.(e);
      } finally {
        button.disabled = false;
      }
    }
  }

  if (!customElements.get('nordri-wishlist')) customElements.define('nordri-wishlist', NordriWishlist);

  } catch(e) { console.error(e); }
})();
})();
